export const initialState = {
  version: "N/A",
  date: "N/A"
};

export const translation = {
  app: {
    label: "Settings.Versions.AppVersionLabel",
    value: "Settings.Versions.SettingsVersionValue"
  },
  databaseVersion: {
    label: "Settings.Versions.DatabaseVersionLabel",
    value: "Settings.Versions.DatabaseVersionValue"
  }
};
